import {
  Labels,
  postHistogram,
} from '~/utils/metrics/specta/requests/postHistogram'

type MetricName = 'page_ready_duration_seconds' | 'another_metric_name'

// To avoid reporting the same metric multiple times we use a Set
// That way `reportOnce` can be called multiple times without sending duplicate metrics.
// Means we can just fire and forget from react components that might render multiple times.
const reportedMetrics = new Set<MetricName>()

const report = (name: MetricName, labels: Labels, duration: number) => {
  if (reportedMetrics.has(name)) return // Already reported
  reportedMetrics.add(name)

  try {
    postHistogram({
      metric: name,
      labels,
      number: duration / 1000,
    })
  } catch {
    // Ignore errors in reporting metrics
  }
}

export const Metrics = {
  report,
}
